import { AutomatedIconWrapper } from './Jim.styled';

export const JimIcon = ({ size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0229 18.6318C23.083 17.6706 23.74 16.3443 23.8619 14.919C24.06 11.7246 24.0449 8.52048 23.8169 5.328C23.7058 3.99883 23.1218 2.75346 22.1708 1.81778C21.2198 0.882104 19.9648 0.318078 18.6334 0.228C16.4963 0.075 14.2452 0 11.9941 0C9.74305 0 7.49197 0.075 5.35493 0.228C4.02755 0.320454 2.77692 0.883992 1.82865 1.81695C0.880371 2.74992 0.296877 3.99089 0.183427 5.316C-0.0450622 8.51144 -0.0601029 11.7186 0.138405 14.916C0.259484 16.3398 0.91446 17.6651 1.97204 18.6265C3.02964 19.5879 4.41169 20.1142 5.84117 20.1H8.99268V24L14.9956 20.1H18.1471C19.5782 20.1174 20.9628 19.5928 22.0229 18.6318ZM14.9956 16.2L8.99268 20.1V16.2H5.83517C5.39027 16.2164 4.95561 16.0642 4.61831 15.7738C4.281 15.4833 4.06596 15.0762 4.01629 14.634C3.8328 11.6363 3.84784 8.62976 4.06131 5.634C4.09745 5.23439 4.27624 4.86113 4.56502 4.58242C4.85379 4.3037 5.23325 4.13814 5.63407 4.116C7.68106 3.972 9.83613 3.9 11.9941 3.9C14.1522 3.9 16.3073 3.978 18.3543 4.104C18.7551 4.12614 19.1346 4.2917 19.4233 4.57042C19.712 4.84913 19.8909 5.22239 19.927 5.622C20.1405 8.61776 20.1555 11.6243 19.972 14.622C19.9252 15.0664 19.7113 15.4764 19.3737 15.7693C19.0361 16.0622 18.5999 16.2162 18.1531 16.2H14.9956ZM15.3764 11.2542C15.6967 11.2439 16.0267 11.2333 16.2759 11.4798C16.5747 11.7753 16.5747 12.2185 16.2759 12.514C15.0809 13.696 13.5124 14.25 11.9813 14.25C10.4502 14.25 8.88175 13.6591 7.72407 12.514C7.42533 12.2185 7.42529 11.7753 7.72407 11.4798C7.96832 11.2383 8.1647 11.2435 8.53556 11.2535C8.61835 11.2557 8.70984 11.2582 8.8125 11.2582L15.1875 11.2582C15.2496 11.2582 15.3128 11.2562 15.3764 11.2542ZM12.7784 8.41391C13.1455 7.40413 14.0207 6.75025 15.0077 6.75C15.9743 6.75054 16.8422 7.38397 17.219 8.36508C17.2908 8.55311 17.2351 8.76493 17.0813 8.88105C16.9275 8.99716 16.7275 8.97807 16.5947 8.83604C15.8759 8.06728 14.7388 7.45024 13.4056 8.87804C13.3306 8.95884 13.2332 8.9992 13.1361 9C13.0618 9.00037 12.9871 8.97559 12.9202 8.92695C12.7682 8.81364 12.71 8.60265 12.7784 8.41391ZM7.5 7.8746C7.5 7.25487 8.0047 6.75 8.625 6.75C9.24531 6.75 9.75 7.25487 9.75 7.8746C9.75 8.49513 9.24531 9 8.625 9C8.0047 9 7.5 8.49513 7.5 7.8746Z"
            fill="url(#paint0_linear_959_12637)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_959_12637"
                x1="31.2593"
                y1="11.8519"
                x2="-8.2963"
                y2="11.8519"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C182FF" />
                <stop offset="0.494792" stopColor="#8A5DF2" />
                <stop offset="1" stopColor="#533891" />
            </linearGradient>
        </defs>
    </svg>
);

export const JimIconCircled = ({ size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            width="24"
            height="24"
            rx="12"
            fill="#8A5DF2"
            fillOpacity="0.12"
        />
        <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="11.5"
            stroke="#142542"
            strokeOpacity="0.12"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.682 17.4212C19.3886 16.7804 19.8267 15.8962 19.9079 14.946C20.04 12.8164 20.03 10.6803 19.8779 8.552C19.8039 7.66589 19.4145 6.83564 18.7805 6.21186C18.1465 5.58807 17.3099 5.21205 16.4222 5.152C14.9976 5.05 13.4968 5 11.9961 5C10.4954 5 8.99465 5.05 7.56996 5.152C6.68504 5.21364 5.85128 5.58933 5.2191 6.2113C4.58691 6.83328 4.19792 7.66059 4.12228 8.544C3.96996 10.6743 3.95993 12.8124 4.09227 14.944C4.17299 15.8932 4.60964 16.7767 5.3147 17.4177C6.01976 18.0586 6.94112 18.4095 7.89411 18.4H9.99512V21L13.9971 18.4H16.0981C17.0521 18.4116 17.9752 18.0619 18.682 17.4212ZM13.9971 15.8L9.99512 18.4V15.8H7.89011C7.59351 15.8109 7.30374 15.7094 7.07887 15.5158C6.854 15.3222 6.71064 15.0508 6.67752 14.756C6.5552 12.7575 6.56522 10.7532 6.70754 8.756C6.73164 8.48959 6.85083 8.24075 7.04334 8.05494C7.23586 7.86913 7.48883 7.75876 7.75605 7.744C9.12071 7.648 10.5574 7.6 11.9961 7.6C13.4348 7.6 14.8715 7.652 16.2362 7.736C16.5034 7.75076 16.7564 7.86113 16.9488 8.04694C17.1414 8.23275 17.2606 8.4816 17.2847 8.748C17.427 10.7452 17.437 12.7495 17.3147 14.748C17.2835 15.0443 17.1409 15.3176 16.9158 15.5129C16.6907 15.7082 16.3999 15.8108 16.1021 15.8H13.9971ZM14.251 12.5028C14.4645 12.4959 14.6844 12.4889 14.8506 12.6532C15.0498 12.8502 15.0498 13.1457 14.8506 13.3427C14.0539 14.1306 13.0083 14.5 11.9875 14.5C10.9668 14.5 9.92117 14.106 9.14938 13.3427C8.95022 13.1457 8.9502 12.8502 9.14938 12.6532C9.31221 12.4922 9.44313 12.4957 9.69037 12.5023C9.74557 12.5038 9.80656 12.5055 9.875 12.5055L14.125 12.5055C14.1664 12.5055 14.2086 12.5041 14.251 12.5028ZM12.5189 10.6093C12.7637 9.93608 13.3471 9.50017 14.0051 9.5C14.6495 9.50036 15.2281 9.92265 15.4793 10.5767C15.5272 10.7021 15.49 10.8433 15.3875 10.9207C15.285 10.9981 15.1517 10.9854 15.0632 10.8907C14.5839 10.3782 13.8258 9.96683 12.937 10.9187C12.8871 10.9726 12.8221 10.9995 12.7574 11C12.7078 11.0002 12.658 10.9837 12.6135 10.9513C12.5121 10.8758 12.4733 10.7351 12.5189 10.6093ZM9 10.2497C9 9.83658 9.33646 9.5 9.75 9.5C10.1635 9.5 10.5 9.83658 10.5 10.2497C10.5 10.6634 10.1635 11 9.75 11C9.33646 11 9 10.6634 9 10.2497Z"
            fill="url(#paint0_linear_8_2309)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_8_2309"
                x1="24.8395"
                y1="12.9012"
                x2="-1.53086"
                y2="12.9012"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C182FF" />
                <stop offset="0.494792" stopColor="#8A5DF2" />
                <stop offset="1" stopColor="#533891" />
            </linearGradient>
        </defs>
    </svg>
);

export const JimIconWithBackground = ({ size = 24 }) => (
    <AutomatedIconWrapper size={size}>
        <JimIcon size={size * 0.7} />
    </AutomatedIconWrapper>
);
